import React, { useState } from 'react';
import cn from 'classnames';

import { useElementDimensions, useAppearFromBelow } from '../../util/hooks';

import Card from '../Card';
import Text from '../Text';
import MetaList from '../MetaList';
import Share from '../Share';
import Button from '../Button';

import PanableImage from './PanableImage';

import * as styles from './Artwork.module.css';
import * as textStyles from '../../styles/text.module.css';

const Artwork = ({
  headline,
  intro,
  info,
  image,
  id,
  slug,
  isInFlexLayout
}) => {
  const [showBack, setShowBack] = useState(false);
  const [ref, appeared] = useAppearFromBelow();
  const [wrapperRef, [wrapperWidth, wrapperHeight]] = useElementDimensions();

  return (
    <div
      ref={ref}
      className={cn(styles.root, {
        [styles.flipped]: showBack,
        [styles.isInFlexLayout]: isInFlexLayout,
        [styles.appeared]: appeared
      })}
    >
      <div className={cn(styles.inner)}>
        <Card
          id={id}
          title="Una obra"
          className={cn(styles.front)}
          footer={
            <Button
              className={styles.flipButton}
              onClick={() => setShowBack(true)}
              label="Más"
            />
          }
        >
          <h3 className={cn(textStyles.headline, styles.headline)}>
            {headline}
          </h3>

          <div className={cn(styles.imageWrapper)} ref={wrapperRef}>
            <PanableImage
              image={image}
              containerWidth={wrapperWidth}
              containerHeight={wrapperHeight}
              style={{
                '--affordance-background': 'var(--theme-text-artwork)',
                '--affordance-color': 'var(--theme-card-artwork)'
              }}
              onClick={() => setShowBack(true)}
            />
          </div>
        </Card>

        <Card
          title="Una obra"
          className={cn(styles.back)}
          innerClassName={cn(styles.backInner)}
          footer={
            <Button
              className={styles.flipButton}
              onClick={() => setShowBack(false)}
              label="Cerrar"
            />
          }
        >
          <Text
            className={cn(textStyles.body, styles.artworkText)}
            text={intro}
          />
          <div className={cn(styles.artworkInfo)}>
            {info.map((item, i) => (
              <MetaList key={i} label={item.label} value={item.description} />
            ))}
          </div>
          <Share
            url={`${slug}#${id}`}
            className={cn(styles.share)}
            alignTo="right"
          />
        </Card>
      </div>
    </div>
  );
};

export default Artwork;
